/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Type_A_MessageInputs */

const en_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a message...`)
};

const es_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un mensaje...`)
};

const fr_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez un message...`)
};

const de_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe eine Nachricht...`)
};

const ja_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを入力...`)
};

const zh_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入消息...`)
};

const ar_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتب رسالة...`)
};

const id_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik pesan...`)
};

const it_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi un messaggio...`)
};

const ru_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите сообщение...`)
};

const pt_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite uma mensagem...`)
};

const ko_type_a_message = /** @type {(inputs: Type_A_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지를 입력하세요...`)
};

/**
* | output |
* | --- |
* | "Type a message..." |
*
* @param {Type_A_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const type_a_message = /** @type {((inputs?: Type_A_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Type_A_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_type_a_message(inputs)
	if (locale === "es") return es_type_a_message(inputs)
	if (locale === "fr") return fr_type_a_message(inputs)
	if (locale === "de") return de_type_a_message(inputs)
	if (locale === "ja") return ja_type_a_message(inputs)
	if (locale === "zh") return zh_type_a_message(inputs)
	if (locale === "ar") return ar_type_a_message(inputs)
	if (locale === "id") return id_type_a_message(inputs)
	if (locale === "it") return it_type_a_message(inputs)
	if (locale === "ru") return ru_type_a_message(inputs)
	if (locale === "pt") return pt_type_a_message(inputs)
	return ko_type_a_message(inputs)
});